import { createFileRoute } from '@tanstack/react-router';
import { validateTableSearch } from '@utils/tabHelpers';

type DocumentsTab = 'all' | 'signing-requests';

function parseTab(value: unknown): DocumentsTab {
  return value === 'signing-requests' ? 'signing-requests' : 'all';
}

export const Route = createFileRoute('/w/documents/')({
  validateSearch: (search: Record<string, unknown>) => ({
    ...validateTableSearch(search, { sortBy: 'updatedOn', sortDir: 'desc' }),
    tab: parseTab(search.tab),
  }),
});
